import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';


const styles = theme => ({
  root: {
    minWidth: theme.dimensions.md,
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    width: '100%',
  },
  continueButton: {
    padding: theme.spacing(1),
  },
  stepNavigationContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    padding: theme.spacing(3),
  },
});

const FacetPlan403BStrategyContributionDetailsStep = ({
  className,
  classes,
}) => {
  const { resource } = useMetaLayoutContext();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <MetaField
        disabled={resource.attr('shouldMaxContributions') === 'true'}
        attr={'target'}
      />
      <MetaField
        disabled={resource.attr('target') !== '0' && resource.attr('target') !== ''}
        attr={'shouldMaxContributions'}
      />
      <MetaField
        attr={'targetConfidenceLevel'}
      />
      <MetaField
        attr={'isEligibleForMaxContributions'}
      />
      <MetaField
        disabled={resource.attr('isEligibleForMaxContributions') !== 'true'}
        attr={'yearsEmployedInJob'}
      />
      <MetaField attr={'isSuperFunded'} />
    </Box>
  );
};

FacetPlan403BStrategyContributionDetailsStep.defaultProps = {
  className: '',
};

FacetPlan403BStrategyContributionDetailsStep.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FacetPlan403BStrategyContributionDetailsStep);
